import {
    BANKMASTER_ADDUPDATE_SUCCESS,
    BANKMASTER_ADDUPDATE_FAILED,
    RESET_BANKMASTER_ADDUPDATE,
    LOADING_BANKMASTER_ADDUPDATE,
    BANKMASTER_ADDUPDATE_NETWORKERROR,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_BANKMASTER_ADDUPDATE:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case BANKMASTER_ADDUPDATE_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case BANKMASTER_ADDUPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case BANKMASTER_ADDUPDATE_NETWORKERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_BANKMASTER_ADDUPDATE:
            return (state = initialState);
        default:
            return state;
    }
};
